var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bootstrap" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.modals.overlay,
              expression: "modals.overlay"
            }
          ],
          staticClass: "comment-overlay"
        },
        [
          _c(
            "form",
            {
              staticClass: "buttons",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.saveComments.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-close",
                  attrs: { type: "button" },
                  on: { click: _vm.cancelComments }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  attrs: { type: "submit", disabled: _vm.loading.save }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.loading.save
                          ? "Saving comment(s)..."
                          : "Save comment(s)"
                      ) +
                      "\n      "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "commentImage" }, [
            _c(
              "div",
              { staticStyle: { position: "relative" } },
              [
                _c("img", { attrs: { src: _vm.commentImage } }),
                _vm._v(" "),
                _vm._l(_vm.comments, function(comment, index) {
                  return _c(
                    "a",
                    {
                      staticClass: "index",
                      class: _vm.getIndexClassName(index),
                      style: {
                        left: comment.pcX + "%",
                        top: comment.pcY + "%"
                      },
                      attrs: { href: "#", title: comment.comment },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.editComment(index)
                        }
                      }
                    },
                    [_vm._v("\n          " + _vm._s(index + 1) + "\n        ")]
                  )
                })
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          style: { position: "absolute" },
          attrs: {
            title: "Add a comment",
            size: "xl",
            id: "trial-comments-modal"
          },
          on: {
            ok: _vm.saveComment,
            cancel: _vm.cancelComment,
            hide: _vm.cancelComment,
            shown: _vm.modalShown
          },
          model: {
            value: _vm.modals.comment,
            callback: function($$v) {
              _vm.$set(_vm.modals, "comment", $$v)
            },
            expression: "modals.comment"
          }
        },
        [
          _c("label", { staticStyle: { width: "100%" } }, [
            _c("span", { staticClass: "label-title" }, [
              _vm._v("\n        Screen: "),
              _c("b", [_vm._v(_vm._s(this.screen))]),
              _vm._v(" "),
              _c("br"),
              _c("br")
            ])
          ]),
          _vm._v(" "),
          _c("label", { staticStyle: { width: "100%" } }, [
            _c("span", { staticClass: "label-title" }, [
              _vm._v("Please type the comment: "),
              _c("sup", [_vm._v("*")])
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.comment,
                  expression: "comment"
                }
              ],
              ref: "commentBox",
              staticClass: "form-control comment-box",
              staticStyle: { width: "100%" },
              domProps: { value: _vm.comment },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.comment = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("br")
          ]),
          _vm._v(" "),
          _c("label", { staticStyle: { width: "100%" } }, [
            _c("span", { staticClass: "label-title" }, [
              _vm._v("Assign to user:")
            ]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.user,
                    expression: "user"
                  }
                ],
                staticStyle: {
                  padding: "0 10px",
                  width: "100%",
                  height: "30px",
                  "margin-top": "10px"
                },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.user = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { domProps: { value: null } }, [
                  _vm._v("- Unassigned -")
                ]),
                _vm._v(" "),
                _vm._l(_vm.users(), function(u) {
                  return _c("option", { domProps: { value: u.id } }, [
                    _vm._v("\n          " + _vm._s(u.name) + "\n        ")
                  ])
                })
              ],
              2
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-571264c4", { render: render, staticRenderFns: staticRenderFns })
  }
}